import { checkSafeliteCanRepairAllRecalParts } from "@/helpers/recal-helper";
import { routeData } from "@/router/constants/routes";
import store from "@/store";

export async function recalibrationInfoBeforeEnter(to, from) {
    const hasRecalibration = store.getters.isRecalibrationOnOrder;
    const canPerformRecalibration = checkSafeliteCanRepairAllRecalParts(store.getters.lineItems);

    if (!hasRecalibration || !canPerformRecalibration) {
        if (from.name === routeData.COVERAGE_STATEMENT.name) {
            return {
                name: routeData.POLICY_INFO.name,
            };
        } else {
            return {
                name: routeData.COVERAGE_STATEMENT.name,
            };
        }
    }
}
